import { Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslate } from "src/locales";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import { PAGE_THREE_STYLES } from "../constants";
import { PageThreeFormData } from "../models";

const ReproductiveField = ({
  label,
  name,
  options = [],
  control,
  t
}: {
  label: string;
  name: keyof PageThreeFormData;
  options?: any[];
  control: any;
  t: any;
}) => (
  <Grid md={3} xs={12} sx={PAGE_THREE_STYLES.gridItem}>
    <Grid sx={PAGE_THREE_STYLES.gridPadding}>
      <ByzMuiTypography sx={PAGE_THREE_STYLES.label}>
        {t(label)}
      </ByzMuiTypography>
    </Grid>
    <Grid sx={PAGE_THREE_STYLES.gridPadding}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <ByzMuiSelect
            {...field}
            options={options}
            label={t("open-process-menu.select")}
            renderInput={(params: any) => <ByzMuiTextField {...params} />}
            sx={PAGE_THREE_STYLES.select}
          />
        )}
      />
    </Grid>
  </Grid>
);

const ReproductivePattern: React.FC = () => {
  const { t } = useTranslate();
  const { control } = useFormContext<PageThreeFormData>();

  return (
    <>
      <Grid sx={PAGE_THREE_STYLES.sectionTitle}>
        <ByzMuiTypography isTitle paddingRight="20px" paddingTop="5px">
          {t("adult-patient-assessment.reproductive-pattern")}
        </ByzMuiTypography>
      </Grid>

      <Stack direction="row" sx={{ paddingTop: "10px" }} flexWrap="wrap">
        <ReproductiveField label="adult-patient-assessment.menarche-age" name="menarcheAge" control={control} t={t} />
        <ReproductiveField label="adult-patient-assessment.menopause-age" name="menopauseAge" control={control} t={t} />
        <ReproductiveField label="adult-patient-assessment.gravida" name="gravida" control={control} t={t} />
        <ReproductiveField label="adult-patient-assessment.para" name="para" control={control} t={t} />
        <ReproductiveField label="adult-patient-assessment.abortion" name="abortion" control={control} t={t} />
        <ReproductiveField label="adult-patient-assessment.living-children" name="livingChildren" control={control} t={t} />
        <ReproductiveField label="adult-patient-assessment.delivery-method" name="deliveryMethod" control={control} t={t} />
        <ReproductiveField label="adult-patient-assessment.contraceptive-method" name="contraceptiveMethod" control={control} t={t} />
      </Stack>
    </>
  );
};

export default ReproductivePattern;
